// Lazy load function
const lazyLoad = (file) => () =>
  import(/* webpackChunkName: "[request]" */ `@/views/settings/${file}.vue`);

export default [
  {
    path: "/settings/:type*",
    name: "settings",
    meta: { requiresAuth: true },
    components: {
      content: lazyLoad("settings-list"),
    },
  },

  {
    path: "/currency",
    name: "currency",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CompanyCurrency",
    },
    components: {
      content: lazyLoad("accounting/currency"),
    },
  },
  {
    path: "/currency/review/:id",
    name: "currency-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CompanyCurrency",
    },
    components: {
      content: lazyLoad("accounting/currency"),
    },
  },
  {
    path: "/currency/edit/:id",
    name: "currency-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CompanyCurrency",
    },
    components: {
      content: lazyLoad("accounting/currency"),
    },
  },
  {
    path: "/currency/create",
    name: "currency-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CompanyCurrency",
    },
    components: {
      content: lazyLoad("accounting/currency"),
    },
  },

  {
    path: "/tax-category",
    name: "tax-category",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "Tax",
    },
    components: {
      content: lazyLoad("accounting/tax-category"),
    },
  },
  {
    path: "/tax-category/review/:id",
    name: "tax-category-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "Tax",
    },
    components: {
      content: lazyLoad("accounting/tax-category"),
    },
  },
  {
    path: "/tax-category/edit/:id",
    name: "tax-category-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "Tax",
    },
    components: {
      content: lazyLoad("accounting/tax-category"),
    },
  },
  {
    path: "/tax-category/create",
    name: "tax-category-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "Tax",
    },
    components: {
      content: lazyLoad("accounting/tax-category"),
    },
  },
  {
    path: "/accounting-periods",
    name: "accounting-periods",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AccountingPeriods",
    },
    components: {
      content: lazyLoad("accounting/accounting-periods"),
    },
  },
  {
    path: "/branch",
    name: "branch",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "Branch",
    },
    components: {
      content: lazyLoad("company/branch"),
    },
  },
  {
    path: "/branch/review/:id",
    name: "branch-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "Branch",
    },
    components: {
      content: lazyLoad("company/branch"),
    },
  },
  {
    path: "/branch/edit/:id",
    name: "branch-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "Branch",
    },
    components: {
      content: lazyLoad("company/branch"),
    },
  },
  {
    path: "/branch/create",
    name: "branch-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "Branch",
    },
    components: {
      content: lazyLoad("company/branch"),
    },
  },

  {
    path: "/company/review/:id",
    name: "company-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "Company",
    },
    components: {
      content: lazyLoad("company/company"),
    },
  },

  {
    path: "/company/edit/:id",
    name: "company-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "Company",
    },
    components: {
      content: lazyLoad("company/company"),
    },
  },
  {
    path: "/company/create",
    name: "company-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "Company",
    },
    components: {
      content: lazyLoad("company/company"),
    },
  },

  // Division
  {
    path: "/division",
    name: "division",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "Division",
    },
    components: {
      content: lazyLoad("company/division"),
    },
  },
  {
    path: "/division/review/:id",
    name: "division-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "Division",
    },
    components: {
      content: lazyLoad("company/division"),
    },
  },
  {
    path: "/division/edit/:id",
    name: "division-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "Division",
    },
    components: {
      content: lazyLoad("company/division"),
    },
  },
  {
    path: "/division/create",
    name: "division-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "Division",
    },
    components: {
      content: lazyLoad("company/division"),
    },
  },

  {
    path: "/customer-contract-line-description",
    name: "customer-contract-line-description",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerContractLineDescription",
    },
    components: {
      content: lazyLoad("customers/customer-contract-line-description"),
    },
  },
  {
    path: "/customer-contract-line-description/review/:id",
    name: "customer-contract-line-description-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerContractLineDescription",
    },
    components: {
      content: lazyLoad("customers/customer-contract-line-description"),
    },
  },
  {
    path: "/customer-contract-line-description/edit/:id",
    name: "customer-contract-line-description-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerContractLineDescription",
    },
    components: {
      content: lazyLoad("customers/customer-contract-line-description"),
    },
  },
  {
    path: "/customer-contract-line-description/create",
    name: "customer-contract-line-description-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerContractLineDescription",
    },
    components: {
      content: lazyLoad("customers/customer-contract-line-description"),
    },
  },

  // settings - Drop Codes
  {
    path: "/drop-code",
    name: "drop-code",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "DropCode",
    },
    components: {
      content: lazyLoad("customers/drop-code"),
    },
  },
  {
    path: "/drop-code/review/:id",
    name: "drop-code-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "DropCode",
    },
    components: {
      content: lazyLoad("customers/drop-code"),
    },
  },
  {
    path: "/drop-code/edit/:id",
    name: "drop-code-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "DropCode",
    },
    components: {
      content: lazyLoad("customers/drop-code"),
    },
  },
  {
    path: "/drop-code/create",
    name: "drop-code-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "DropCode",
    },
    components: {
      content: lazyLoad("customers/drop-code"),
    },
  },

  {
    path: "/customer-group",
    name: "customer-group",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerGroup",
    },
    components: {
      content: lazyLoad("customers/customer-group"),
    },
  },
  {
    path: "/customer-group/review/:id",
    name: "customer-group-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerGroup",
    },
    components: {
      content: lazyLoad("customers/customer-group"),
    },
  },
  {
    path: "/customer-group/edit/:id",
    name: "customer-group-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerGroup",
    },
    components: {
      content: lazyLoad("customers/customer-group"),
    },
  },
  {
    path: "/customer-group/create",
    name: "customer-group-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerGroup",
    },
    components: {
      content: lazyLoad("customers/customer-group"),
    },
  },

  // CustomerMarket
  {
    path: "/customer-market",
    name: "customer-market",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerMarket",
    },
    components: {
      content: lazyLoad("customers/customer-market"),
    },
  },

  {
    path: "/customer-market/review/:id",
    name: "customer-market-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerMarket",
    },
    components: {
      content: lazyLoad("customers/customer-market"),
    },
  },

  {
    path: "/Customer-Market/create",
    name: "Customer-Market-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerMarket",
    },
    components: {
      content: lazyLoad("customers/customer-market"),
    },
  },

  {
    path: "/customer-market/edit/:id",
    name: "customer-market-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerMarket",
    },
    components: {
      content: lazyLoad("customers/customer-market"),
    },
  },

  // Customer Region
  {
    path: "/customer-region",
    name: "customer-region",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerRegion",
    },
    components: {
      content: lazyLoad("customers/customer-region"),
    },
  },
  {
    path: "/customer-region/create",
    name: "customer-region-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerRegion",
    },
    components: {
      content: lazyLoad("customers/customer-region"),
    },
  },
  {
    path: "/customer-region/review/:id",
    name: "customer-region-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerRegion",
    },
    components: {
      content: lazyLoad("customers/customer-region"),
    },
  },
  {
    path: "/customer-region/edit/:id",
    name: "customer-region-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerRegion",
    },
    components: {
      content: lazyLoad("customers/customer-region"),
    },
  },

  // Customer Reporting Group1
  {
    path: "/customer-reporting-group-1",
    name: "customer-reporting-group-1",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerReportingGroup1",
    },
    components: {
      content: lazyLoad("customers/reporting-group-1"),
    },
  },
  {
    path: "/customer-reporting-group-1/create",
    name: "customer-reporting-group-1-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerReportingGroup1",
    },
    components: {
      content: lazyLoad("customers/reporting-group-1"),
    },
  },
  {
    path: "/customer-reporting-group-1/review/:id",
    name: "customer-reporting-group-1-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerReportingGroup1",
    },
    components: {
      content: lazyLoad("customers/reporting-group-1"),
    },
  },
  {
    path: "/customer-reporting-group-1/edit/:id",
    name: "customer-reporting-group-1-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerReportingGroup1",
    },
    components: {
      content: lazyLoad("customers/reporting-group-1"),
    },
  },

  // Customer Reporting Group2
  {
    path: "/customer-reporting-group-2",
    name: "customer-reporting-group-2",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerReportingGroup2",
    },
    components: {
      content: lazyLoad("customers/reporting-group-2"),
    },
  },
  {
    path: "/customer-reporting-group-2/create",
    name: "customer-reporting-group-2-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerReportingGroup2",
    },
    components: {
      content: lazyLoad("customers/reporting-group-2"),
    },
  },
  {
    path: "/customer-reporting-group-2/review/:id",
    name: "customer-reporting-group-2-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerReportingGroup2",
    },
    components: {
      content: lazyLoad("customers/reporting-group-2"),
    },
  },
  {
    path: "/customer-reporting-group-2/edit/:id",
    name: "customer-reporting-group-2-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerReportingGroup2",
    },
    components: {
      content: lazyLoad("customers/reporting-group-2"),
    },
  },
  // Customer Reporting Group3
  {
    path: "/customer-reporting-group-3",
    name: "customer-reporting-group-3",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerReportingGroup3",
    },
    components: {
      content: lazyLoad("customers/reporting-group-3"),
    },
  },
  {
    path: "/customer-reporting-group-3/create",
    name: "customer-reporting-group-3-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerReportingGroup3",
    },
    components: {
      content: lazyLoad("customers/reporting-group-3"),
    },
  },
  {
    path: "/customer-reporting-group-3/review/:id",
    name: "customer-reporting-group-3-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerReportingGroup3",
    },
    components: {
      content: lazyLoad("customers/reporting-group-3"),
    },
  },
  {
    path: "/customer-reporting-group-3/edit/:id",
    name: "customer-reporting-group-3-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerReportingGroup3",
    },
    components: {
      content: lazyLoad("customers/reporting-group-3"),
    },
  },

  // Customer SalesRepresentative
  {
    path: "/customer-sales-representative",
    name: "customer-sales-representative",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerSalesRepresentative",
    },
    components: {
      content: lazyLoad("customers/customer-sales-representative"),
    },
  },
  {
    path: "/customer-sales-representative/create",
    name: "customer-sales-representative/create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerSalesRepresentative",
    },
    components: {
      content: lazyLoad("customers/customer-sales-representative"),
    },
  },
  {
    path: "/customer-sales-representative/review/:id",
    name: "customer-sales-representative-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerSalesRepresentative",
    },
    components: {
      content: lazyLoad("customers/customer-sales-representative"),
    },
  },
  {
    path: "/customer-sales-representative/edit/:id",
    name: "customer-sales-representative-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerSalesRepresentative",
    },
    components: {
      content: lazyLoad("customers/customer-sales-representative"),
    },
  },

  // Customer Sub Region
  {
    path: "/customer-sub-region",
    name: "customer-sub-region",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerSubRegion",
    },
    components: {
      content: lazyLoad("customers/customer-sub-region"),
    },
  },
  {
    path: "/customer-Sub-region/create",
    name: "customer-Sub-region-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerSubRegion",
    },
    components: {
      content: lazyLoad("customers/customer-sub-region"),
    },
  },
  {
    path: "/customer-sub-region/review/:id",
    name: "customer-sub-region-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerSubRegion",
    },
    components: {
      content: lazyLoad("customers/customer-sub-region"),
    },
  },
  {
    path: "/customer-sub-region/edit/:id",
    name: "customer-sub-region-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerSubRegion",
    },
    components: {
      content: lazyLoad("customers/customer-sub-region"),
    },
  },

  {
    path: "/customer-type",
    name: "customer-type",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerType",
    },
    components: {
      content: lazyLoad("customers/customer-type"),
    },
  },
  {
    path: "/customer-type/review/:id",
    name: "customer-type-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerType",
    },
    components: {
      content: lazyLoad("customers/customer-type"),
    },
  },
  {
    path: "/customer-type/edit/:id",
    name: "customer-type-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerType",
    },
    components: {
      content: lazyLoad("customers/customer-type"),
    },
  },
  {
    path: "/customer-type/create",
    name: "customer-type-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CustomerType",
    },
    components: {
      content: lazyLoad("customers/customer-type"),
    },
  },
  // Settings - Bil Location Type
  {
    path: "/bin-location-type",
    name: "bin-location-type",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BinLocation",
    },
    components: {
      content: lazyLoad("products/bin-location-type"),
    },
  },
  {
    path: "/bin-location-type/review/:id",
    name: "bin-location-type-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BinLocation",
    },
    components: {
      content: lazyLoad("products/bin-location-type"),
    },
  },
  {
    path: "/bin-location-type/edit/:id",
    name: "bin-location-type-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BinLocation",
    },
    components: {
      content: lazyLoad("products/bin-location-type"),
    },
  },
  {
    path: "/bin-location-type/create",
    name: "bin-location-type-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BinLocation",
    },
    components: {
      content: lazyLoad("products/bin-location-type"),
    },
  },

  {
    path: "/bin-location",
    name: "bin-location",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BinLocation",
    },
    components: {
      content: lazyLoad("products/bin-location"),
    },
  },
  {
    path: "/bin-location/review/:id",
    name: "bin-location-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BinLocation",
    },
    components: {
      content: lazyLoad("products/bin-location"),
    },
  },
  {
    path: "/bin-location/edit/:id",
    name: "bin-location-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BinLocation",
    },
    components: {
      content: lazyLoad("products/bin-location"),
    },
  },
  {
    path: "/bin-location/create",
    name: "bin-location-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BinLocation",
    },
    components: {
      content: lazyLoad("products/bin-location"),
    },
  },

  {
    path: "/product-category-1",
    name: "product-category-1",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductCategory1",
    },
    components: {
      content: lazyLoad("products/product-category-1"),
    },
  },
  {
    path: "/product-category-1/review/:id",
    name: "product-category-1-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductCategory1",
    },
    components: {
      content: lazyLoad("products/product-category-1"),
    },
  },
  {
    path: "/product-category-1/edit/:id",
    name: "product-category-1-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductCategory1",
    },
    components: {
      content: lazyLoad("products/product-category-1"),
    },
  },
  {
    path: "/product-category-1/create",
    name: "product-category-1-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductCategory1",
    },
    components: {
      content: lazyLoad("products/product-category-1"),
    },
  },

  {
    path: "/product-category-2",
    name: "product-category-2",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductCategory2",
    },
    components: {
      content: lazyLoad("products/product-category-2"),
    },
  },
  {
    path: "/product-category-2/review/:id",
    name: "product-category-2-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductCategory2",
    },
    components: {
      content: lazyLoad("products/product-category-2"),
    },
  },
  {
    path: "/product-category-2/edit/:id",
    name: "product-category-2-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductCategory2",
    },
    components: {
      content: lazyLoad("products/product-category-2"),
    },
  },
  {
    path: "/product-category-2/create",
    name: "product-category-2-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductCategory2",
    },
    components: {
      content: lazyLoad("products/product-category-2"),
    },
  },

  {
    path: "/product-category-3",
    name: "product-category-3",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductCategory3",
    },
    components: {
      content: lazyLoad("products/product-category-3"),
    },
  },
  {
    path: "/product-category-3/review/:id",
    name: "product-category-3-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductCategory3",
    },
    components: {
      content: lazyLoad("products/product-category-3"),
    },
  },
  {
    path: "/product-category-3/edit/:id",
    name: "product-category-3-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductCategory3",
    },
    components: {
      content: lazyLoad("products/product-category-3"),
    },
  },
  {
    path: "/product-category-3/create",
    name: "product-category-3-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductCategory3",
    },
    components: {
      content: lazyLoad("products/product-category-3"),
    },
  },

  {
    path: "/product-category-4",
    name: "product-category-4",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductCategory4",
    },
    components: {
      content: lazyLoad("products/product-category-4"),
    },
  },
  {
    path: "/product-category-4/review/:id",
    name: "product-category-4-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductCategory4",
    },
    components: {
      content: lazyLoad("products/product-category-4"),
    },
  },
  {
    path: "/product-category-4/edit/:id",
    name: "product-category-4-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductCategory4",
    },
    components: {
      content: lazyLoad("products/product-category-4"),
    },
  },
  {
    path: "/product-category-4/create",
    name: "product-category-4-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductCategory4",
    },
    components: {
      content: lazyLoad("products/product-category-4"),
    },
  },

  {
    path: "/category-labels",
    name: "category-labels",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "EditCategoryLabels",
    },
    components: {
      content: lazyLoad("products/category-labels"),
    },
  },
  {
    path: "/category-labels/edit",
    name: "category-labels-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "EditCategoryLabels",
    },
    components: {
      content: lazyLoad("products/category-labels"),
    },
  },

  {
    path: "/product-filter-group",
    name: "product-filter-group-list",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductFilterGroup",
    },
    components: {
      content: lazyLoad("products/product-filter-group-list"),
    },
  },
  {
    path: "/product-filter-group/create",
    name: "product-filter-group-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductFilterGroup",
    },
    components: {
      content: lazyLoad("products/product-filter-group"),
    },
  },
  {
    path: "/product-filter-group/review/:id",
    name: "product-filter-group-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductFilterGroup",
    },
    components: {
      content: lazyLoad("products/product-filter-group"),
    },
  },
  {
    path: "/product-filter-group/edit/:id",
    name: "product-filter-group-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductFilterGroup",
    },
    components: {
      content: lazyLoad("products/product-filter-group"),
    },
  },

  // product-attribute
  // Start 01
  {
    path: "/product-attribute-01",
    name: "product-attribute-01",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute01",
    },
    components: {
      content: lazyLoad("products/product-attribute-01"),
    },
  },
  {
    path: "/product-attribute-01/review/:id",
    name: "product-attribute-01-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute01",
    },
    components: {
      content: lazyLoad("products/product-attribute-01"),
    },
  },
  {
    path: "/product-attribute-01/edit/:id",
    name: "product-attribute-01-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute01",
    },
    components: {
      content: lazyLoad("products/product-attribute-01"),
    },
  },
  {
    path: "/product-attribute-01/create",
    name: "product-attribute-01-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute01",
    },
    components: {
      content: lazyLoad("products/product-attribute-01"),
    },
  },
  // End 01
  // Start 02
  {
    path: "/product-attribute-02",
    name: "product-attribute-02",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute02",
    },
    components: {
      content: lazyLoad("products/product-attribute-02"),
    },
  },
  {
    path: "/product-attribute-02/review/:id",
    name: "product-attribute-02-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute02",
    },
    components: {
      content: lazyLoad("products/product-attribute-02"),
    },
  },
  {
    path: "/product-attribute-02/edit/:id",
    name: "product-attribute-02-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute02",
    },
    components: {
      content: lazyLoad("products/product-attribute-02"),
    },
  },
  {
    path: "/product-attribute-02/create",
    name: "product-attribute-02-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute02",
    },
    components: {
      content: lazyLoad("products/product-attribute-02"),
    },
  },
  // End 02

  // Start 03
  {
    path: "/product-attribute-03",
    name: "product-attribute-03",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute03",
    },
    components: {
      content: lazyLoad("products/product-attribute-03"),
    },
  },
  {
    path: "/product-attribute-03/review/:id",
    name: "product-attribute-03-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute03",
    },
    components: {
      content: lazyLoad("products/product-attribute-03"),
    },
  },
  {
    path: "/product-attribute-03/edit/:id",
    name: "product-attribute-03-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute03",
    },
    components: {
      content: lazyLoad("products/product-attribute-03"),
    },
  },
  {
    path: "/product-attribute-03/create",
    name: "product-attribute-03-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute03",
    },
    components: {
      content: lazyLoad("products/product-attribute-03"),
    },
  },
  // End 03
  // Start 04
  {
    path: "/product-attribute-04",
    name: "product-attribute-04",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute04",
    },
    components: {
      content: lazyLoad("products/product-attribute-04"),
    },
  },
  {
    path: "/product-attribute-04/review/:id",
    name: "product-attribute-04-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute04",
    },
    components: {
      content: lazyLoad("products/product-attribute-04"),
    },
  },
  {
    path: "/product-attribute-04/edit/:id",
    name: "product-attribute-04-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute04",
    },
    components: {
      content: lazyLoad("products/product-attribute-04"),
    },
  },
  {
    path: "/product-attribute-04/create",
    name: "product-attribute-04-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute04",
    },
    components: {
      content: lazyLoad("products/product-attribute-04"),
    },
  },
  // End 04

  // Start 05
  {
    path: "/product-attribute-05",
    name: "product-attribute-05",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute05",
    },
    components: {
      content: lazyLoad("products/product-attribute-05"),
    },
  },
  {
    path: "/product-attribute-05/review/:id",
    name: "product-attribute-05-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute05",
    },
    components: {
      content: lazyLoad("products/product-attribute-05"),
    },
  },
  {
    path: "/product-attribute-05/edit/:id",
    name: "product-attribute-05-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute05",
    },
    components: {
      content: lazyLoad("products/product-attribute-05"),
    },
  },
  {
    path: "/product-attribute-05/create",
    name: "product-attribute-05-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute05",
    },
    components: {
      content: lazyLoad("products/product-attribute-05"),
    },
  },
  // End 05
  // Start 06
  {
    path: "/product-attribute-06",
    name: "product-attribute-06",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute06",
    },
    components: {
      content: lazyLoad("products/product-attribute-06"),
    },
  },
  {
    path: "/product-attribute-06/review/:id",
    name: "product-attribute-06-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute06",
    },
    components: {
      content: lazyLoad("products/product-attribute-06"),
    },
  },
  {
    path: "/product-attribute-06/edit/:id",
    name: "product-attribute-06-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute06",
    },
    components: {
      content: lazyLoad("products/product-attribute-06"),
    },
  },
  {
    path: "/product-attribute-06/create",
    name: "product-attribute-06-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute06",
    },
    components: {
      content: lazyLoad("products/product-attribute-06"),
    },
  },
  // End 06

  // Start 07
  {
    path: "/product-attribute-07",
    name: "product-attribute-07",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute07",
    },
    components: {
      content: lazyLoad("products/product-attribute-07"),
    },
  },
  {
    path: "/product-attribute-07/review/:id",
    name: "product-attribute-07-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute07",
    },
    components: {
      content: lazyLoad("products/product-attribute-07"),
    },
  },
  {
    path: "/product-attribute-07/edit/:id",
    name: "product-attribute-07-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute07",
    },
    components: {
      content: lazyLoad("products/product-attribute-07"),
    },
  },
  {
    path: "/product-attribute-07/create",
    name: "product-attribute-07-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute07",
    },
    components: {
      content: lazyLoad("products/product-attribute-07"),
    },
  },
  // End 07
  // Start 08
  {
    path: "/product-attribute-08",
    name: "product-attribute-08",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute08",
    },
    components: {
      content: lazyLoad("products/product-attribute-08"),
    },
  },
  {
    path: "/product-attribute-08/review/:id",
    name: "product-attribute-08-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute08",
    },
    components: {
      content: lazyLoad("products/product-attribute-08"),
    },
  },
  {
    path: "/product-attribute-08/edit/:id",
    name: "product-attribute-08-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute08",
    },
    components: {
      content: lazyLoad("products/product-attribute-08"),
    },
  },
  {
    path: "/product-attribute-08/create",
    name: "product-attribute-08-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute08",
    },
    components: {
      content: lazyLoad("products/product-attribute-08"),
    },
  },
  // End 08

  // Start 09
  {
    path: "/product-attribute-09",
    name: "product-attribute-09",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute09",
    },
    components: {
      content: lazyLoad("products/product-attribute-09"),
    },
  },
  {
    path: "/product-attribute-09/review/:id",
    name: "product-attribute-09-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute09",
    },
    components: {
      content: lazyLoad("products/product-attribute-09"),
    },
  },
  {
    path: "/product-attribute-09/edit/:id",
    name: "product-attribute-09-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute09",
    },
    components: {
      content: lazyLoad("products/product-attribute-09"),
    },
  },
  {
    path: "/product-attribute-09/create",
    name: "product-attribute-09-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute09",
    },
    components: {
      content: lazyLoad("products/product-attribute-09"),
    },
  },
  // End 09

  // Start 10
  {
    path: "/product-attribute-10",
    name: "product-attribute-10",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute10",
    },
    components: {
      content: lazyLoad("products/product-attribute-10"),
    },
  },
  {
    path: "/product-attribute-10/review/:id",
    name: "product-attribute-10-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute10",
    },
    components: {
      content: lazyLoad("products/product-attribute-10"),
    },
  },
  {
    path: "/product-attribute-10/edit/:id",
    name: "product-attribute-10-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute10",
    },
    components: {
      content: lazyLoad("products/product-attribute-10"),
    },
  },
  {
    path: "/product-attribute-10/create",
    name: "product-attribute-10-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute10",
    },
    components: {
      content: lazyLoad("products/product-attribute-10"),
    },
  },
  // End 10
  // Start 11
  {
    path: "/product-attribute-11",
    name: "product-attribute-11",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute11",
    },
    components: {
      content: lazyLoad("products/product-attribute-11"),
    },
  },
  {
    path: "/product-attribute-11/review/:id",
    name: "product-attribute-11-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute11",
    },
    components: {
      content: lazyLoad("products/product-attribute-11"),
    },
  },
  {
    path: "/product-attribute-11/edit/:id",
    name: "product-attribute-11-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute11",
    },
    components: {
      content: lazyLoad("products/product-attribute-11"),
    },
  },
  {
    path: "/product-attribute-11/create",
    name: "product-attribute-11-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute11",
    },
    components: {
      content: lazyLoad("products/product-attribute-11"),
    },
  },
  // End 11

  // Start 12
  {
    path: "/product-attribute-12",
    name: "product-attribute-12",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute12",
    },
    components: {
      content: lazyLoad("products/product-attribute-12"),
    },
  },
  {
    path: "/product-attribute-12/review/:id",
    name: "product-attribute-12-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute12",
    },
    components: {
      content: lazyLoad("products/product-attribute-12"),
    },
  },
  {
    path: "/product-attribute-12/edit/:id",
    name: "product-attribute-12-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute12",
    },
    components: {
      content: lazyLoad("products/product-attribute-12"),
    },
  },
  {
    path: "/product-attribute-12/create",
    name: "product-attribute-12-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute12",
    },
    components: {
      content: lazyLoad("products/product-attribute-12"),
    },
  },
  // End 12

  // Start 13
  {
    path: "/product-attribute-13",
    name: "product-attribute-13",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute13",
    },
    components: {
      content: lazyLoad("products/product-attribute-13"),
    },
  },
  {
    path: "/product-attribute-13/review/:id",
    name: "product-attribute-13-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute13",
    },
    components: {
      content: lazyLoad("products/product-attribute-13"),
    },
  },
  {
    path: "/product-attribute-13/edit/:id",
    name: "product-attribute-13-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute13",
    },
    components: {
      content: lazyLoad("products/product-attribute-13"),
    },
  },
  {
    path: "/product-attribute-13/create",
    name: "product-attribute-13-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute13",
    },
    components: {
      content: lazyLoad("products/product-attribute-13"),
    },
  },
  // End 13

  // Start 14
  {
    path: "/product-attribute-14",
    name: "product-attribute-14",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute14",
    },
    components: {
      content: lazyLoad("products/product-attribute-14"),
    },
  },
  {
    path: "/product-attribute-14/review/:id",
    name: "product-attribute-14-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute14",
    },
    components: {
      content: lazyLoad("products/product-attribute-14"),
    },
  },
  {
    path: "/product-attribute-14/edit/:id",
    name: "product-attribute-14-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute14",
    },
    components: {
      content: lazyLoad("products/product-attribute-14"),
    },
  },
  {
    path: "/product-attribute-14/create",
    name: "product-attribute-14-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute14",
    },
    components: {
      content: lazyLoad("products/product-attribute-14"),
    },
  },
  // End 14

  // Start 15
  {
    path: "/product-attribute-15",
    name: "product-attribute-15",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute15",
    },
    components: {
      content: lazyLoad("products/product-attribute-15"),
    },
  },
  {
    path: "/product-attribute-15/review/:id",
    name: "product-attribute-15-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute15",
    },
    components: {
      content: lazyLoad("products/product-attribute-15"),
    },
  },
  {
    path: "/product-attribute-15/edit/:id",
    name: "product-attribute-15-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute15",
    },
    components: {
      content: lazyLoad("products/product-attribute-15"),
    },
  },
  {
    path: "/product-attribute-15/create",
    name: "product-attribute-15-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute15",
    },
    components: {
      content: lazyLoad("products/product-attribute-15"),
    },
  },
  // End 15

  // Start 16
  {
    path: "/product-attribute-16",
    name: "product-attribute-16",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute16",
    },
    components: {
      content: lazyLoad("products/product-attribute-16"),
    },
  },
  {
    path: "/product-attribute-16/review/:id",
    name: "product-attribute-16-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute16",
    },
    components: {
      content: lazyLoad("products/product-attribute-16"),
    },
  },
  {
    path: "/product-attribute-16/edit/:id",
    name: "product-attribute-16-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute16",
    },
    components: {
      content: lazyLoad("products/product-attribute-16"),
    },
  },
  {
    path: "/product-attribute-16/create",
    name: "product-attribute-16-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute16",
    },
    components: {
      content: lazyLoad("products/product-attribute-16"),
    },
  },
  // End 16
  // Start 17
  {
    path: "/product-attribute-17",
    name: "product-attribute-17",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute17",
    },
    components: {
      content: lazyLoad("products/product-attribute-17"),
    },
  },
  {
    path: "/product-attribute-17/review/:id",
    name: "product-attribute-17-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute17",
    },
    components: {
      content: lazyLoad("products/product-attribute-17"),
    },
  },
  {
    path: "/product-attribute-17/edit/:id",
    name: "product-attribute-17-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute17",
    },
    components: {
      content: lazyLoad("products/product-attribute-17"),
    },
  },
  {
    path: "/product-attribute-17/create",
    name: "product-attribute-17-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute17",
    },
    components: {
      content: lazyLoad("products/product-attribute-17"),
    },
  },
  // End 17

  // Start 18
  {
    path: "/product-attribute-18",
    name: "product-attribute-18",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute18",
    },
    components: {
      content: lazyLoad("products/product-attribute-18"),
    },
  },
  {
    path: "/product-attribute-18/review/:id",
    name: "product-attribute-18-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute18",
    },
    components: {
      content: lazyLoad("products/product-attribute-18"),
    },
  },
  {
    path: "/product-attribute-18/edit/:id",
    name: "product-attribute-18-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute18",
    },
    components: {
      content: lazyLoad("products/product-attribute-18"),
    },
  },
  {
    path: "/product-attribute-18/create",
    name: "product-attribute-18-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute18",
    },
    components: {
      content: lazyLoad("products/product-attribute-18"),
    },
  },
  // End 18

  // Start 19
  {
    path: "/product-attribute-19",
    name: "product-attribute-19",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute19",
    },
    components: {
      content: lazyLoad("products/product-attribute-19"),
    },
  },
  {
    path: "/product-attribute-19/review/:id",
    name: "product-attribute-19-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute19",
    },
    components: {
      content: lazyLoad("products/product-attribute-19"),
    },
  },
  {
    path: "/product-attribute-19/edit/:id",
    name: "product-attribute-19-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute19",
    },
    components: {
      content: lazyLoad("products/product-attribute-19"),
    },
  },
  {
    path: "/product-attribute-19/create",
    name: "product-attribute-19-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute19",
    },
    components: {
      content: lazyLoad("products/product-attribute-19"),
    },
  },
  // End 19

  // Start 20
  {
    path: "/product-attribute-20",
    name: "product-attribute-20",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute20",
    },
    components: {
      content: lazyLoad("products/product-attribute-20"),
    },
  },
  {
    path: "/product-attribute-20/review/:id",
    name: "product-attribute-20-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute20",
    },
    components: {
      content: lazyLoad("products/product-attribute-20"),
    },
  },
  {
    path: "/product-attribute-20/edit/:id",
    name: "product-attribute-20-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute20",
    },
    components: {
      content: lazyLoad("products/product-attribute-20"),
    },
  },
  {
    path: "/product-attribute-20/create",
    name: "product-attribute-20-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductAttribute20",
    },
    components: {
      content: lazyLoad("products/product-attribute-20"),
    },
  },
  // End 20

  {
    path: "/product-size",
    name: "product-size",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductSize",
    },
    components: {
      content: lazyLoad("products/product-size"),
    },
  },
  {
    path: "/product-size/review/:id",
    name: "product-size-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductSize",
    },
    components: {
      content: lazyLoad("products/product-size"),
    },
  },
  {
    path: "/product-size/edit/:id",
    name: "product-size-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductSize",
    },
    components: {
      content: lazyLoad("products/product-size"),
    },
  },
  {
    path: "/product-size/create",
    name: "product-size-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductSize",
    },
    components: {
      content: lazyLoad("products/product-size"),
    },
  },

  {
    path: "/product-type",
    name: "product-type",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductType",
    },
    components: {
      content: lazyLoad("products/product-type"),
    },
  },
  {
    path: "/product-type/review/:id",
    name: "product-type-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductType",
    },
    components: {
      content: lazyLoad("products/product-type"),
    },
  },
  {
    path: "/product-type/edit/:id",
    name: "product-type-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductType",
    },
    components: {
      content: lazyLoad("products/product-type"),
    },
  },
  {
    path: "/product-type/create",
    name: "product-type-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductType",
    },
    components: {
      content: lazyLoad("products/product-type"),
    },
  },

  {
    path: "/unit-of-measure",
    name: "unit-of-measure",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "UnitOfMeasure",
    },
    components: {
      content: lazyLoad("products/unit-of-measure"),
    },
  },
  {
    path: "/unit-of-measure/review/:id",
    name: "unit-of-measure-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "UnitOfMeasure",
    },
    components: {
      content: lazyLoad("products/unit-of-measure"),
    },
  },
  {
    path: "/unit-of-measure/edit/:id",
    name: "unit-of-measure-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "UnitOfMeasure",
    },
    components: {
      content: lazyLoad("products/unit-of-measure"),
    },
  },
  {
    path: "/unit-of-measure/create",
    name: "unit-of-measure-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "UnitOfMeasure",
    },
    components: {
      content: lazyLoad("products/unit-of-measure"),
    },
  },

  {
    path: "/call-type",
    name: "call-type",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CallType",
    },
    components: {
      content: lazyLoad("company/call-type"),
    },
  },
  {
    path: "/call-type/review/:id",
    name: "call-type-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CallType",
    },
    components: {
      content: lazyLoad("company/call-type"),
    },
  },
  {
    path: "/call-type/edit/:id",
    name: "call-type-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CallType",
    },
    components: {
      content: lazyLoad("company/call-type"),
    },
  },
  {
    path: "/call-type/create",
    name: "call-type-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "CallType",
    },
    components: {
      content: lazyLoad("company/call-type"),
    },
  },

  // settings - SO Types
  {
    path: "/sales-order-types",
    name: "sales-order-types",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SalesOrderType",
    },
    components: {
      content: lazyLoad("sales/sales-order-type"),
    },
  },
  {
    path: "/sales-order-types/review/:id",
    name: "sales-order-types-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SalesOrderType",
    },
    components: {
      content: lazyLoad("sales/sales-order-type"),
    },
  },
  {
    path: "/sales-order-types/edit/:id",
    name: "sales-order-types-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SalesOrderType",
    },
    components: {
      content: lazyLoad("sales/sales-order-type"),
    },
  },
  {
    path: "/sales-order-types/create",
    name: "sales-order-types-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SalesOrderType",
    },
    components: {
      content: lazyLoad("sales/sales-order-type"),
    },
  },

  {
    path: "/survey-template",
    name: "survey-template",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SurveyTemplate",
    },
    components: {
      content: lazyLoad("sales/survey-template-list"),
    },
  },
  {
    path: "/survey-template/review/:id",
    name: "survey-template-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SurveyTemplate",
    },
    components: {
      content: lazyLoad("sales/survey-template"),
    },
  },
  {
    path: "/survey-template/edit/:id",
    name: "survey-template-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SurveyTemplate",
    },
    components: {
      content: lazyLoad("sales/survey-template"),
    },
  },
  {
    path: "/survey-template/create",
    name: "survey-template-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SurveyTemplate",
    },
    components: {
      content: lazyLoad("sales/survey-template"),
    },
  },

  {
    path: "/supplier-type",
    name: "supplier-type",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SupplierType",
    },
    components: {
      content: lazyLoad("suppliers/supplier-type"),
    },
  },
  {
    path: "/supplier-type/review/:id",
    name: "supplier-type-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SupplierType",
    },
    components: {
      content: lazyLoad("suppliers/supplier-type"),
    },
  },
  {
    path: "/supplier-type/edit/:id",
    name: "supplier-type-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SupplierType",
    },
    components: {
      content: lazyLoad("suppliers/supplier-type"),
    },
  },
  {
    path: "/supplier-type/create",
    name: "supplier-type-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SupplierType",
    },
    components: {
      content: lazyLoad("suppliers/supplier-type"),
    },
  },

  {
    path: "/feature",
    name: "feature",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "FeatureManagement",
    },
    components: {
      content: lazyLoad("graycorp/feature"),
    },
  },
  {
    path: "/feature/edit",
    name: "feature-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "FeatureManagement",
    },
    components: {
      content: lazyLoad("graycorp/feature"),
    },
  },
  {
    path: "/feature-availability",
    name: "feature-availability",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "FeatureAvailability",
    },
    components: {
      content: lazyLoad("graycorp/feature-availability"),
    },
  },
  {
    path: "/feature-availability/edit",
    name: "feature-availability-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "FeatureAvailability",
    },
    components: {
      content: lazyLoad("graycorp/feature-availability"),
    },
  },
  {
    path: "/role-permission",
    name: "role-permission",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "RolePermission",
    },
    components: {
      content: lazyLoad("graycorp/role-permission-list"),
    },
  },
  {
    path: "/role-permission/review/:id",
    name: "role-permission-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "RolePermission",
    },
    components: {
      content: lazyLoad("graycorp/role-permission"),
    },
  },
  {
    path: "/role-permission/edit/:id",
    name: "role-permission-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "RolePermission",
    },
    components: {
      content: lazyLoad("graycorp/role-permission"),
    },
  },

  {
    path: "/menu-management",
    name: "menu-management",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "MenuManagement",
    },
    components: {
      content: lazyLoad("graycorp/menu-management"),
    },
  },

  {
    path: "/user-type",
    name: "user-type",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "UserTypeManagement",
    },
    components: {
      content: lazyLoad("graycorp/user-type"),
    },
  },
  {
    path: "/user-type/edit",
    name: "user-type-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "UserTypeManagement",
    },
    components: {
      content: lazyLoad("graycorp/user-type"),
    },
  },
  {
    path: "/session-management",
    name: "session-management",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "UserManagement",
    },
    components: {
      content: lazyLoad("user/session-management"),
    },
  },

  {
    path: "/user",
    name: "user-list",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "UserManagement",
    },
    components: {
      content: lazyLoad("user/user-list"),
    },
  },
  {
    path: "/user/create",
    name: "user-create",
    meta: { requiresAuth: true, applicationFeatureCode: "UserManagement" },
    components: {
      content: lazyLoad("user/user"),
    },
  },
  {
    path: "/user/review/:id*",
    name: "user-review",
    meta: { requiresAuth: true, applicationFeatureCode: "UserManagement" },
    components: {
      content: lazyLoad("user/user"),
    },
  },
  {
    path: "/user/edit/:id*",
    name: "user-edit",
    meta: { requiresAuth: true, applicationFeatureCode: "UserManagement" },
    components: {
      content: lazyLoad("user/user"),
    },
  },

  // Intake Season
  {
    path: "/season",
    name: "season",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoIntakeSeason",
    },
    components: {
      content: lazyLoad("inventory/intake-season"),
    },
  },
  {
    path: "/season/review/:id",
    name: "season-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoIntakeSeason",
    },
    components: {
      content: lazyLoad("inventory/intake-season"),
    },
  },
  {
    path: "/season/edit/:id",
    name: "season-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoIntakeSeason",
    },
    components: {
      content: lazyLoad("inventory/intake-season"),
    },
  },
  {
    path: "/season/create",
    name: "season-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoIntakeSeason",
    },
    components: {
      content: lazyLoad("inventory/intake-season"),
    },
  },

  {
    path: "/product-attribute-:location",
    name: "product-attributes",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "StorageLocation",
    },
    components: {
      content: lazyLoad("products/product-location-attribute"),
    },
  },

  {
    path: "/product-attribute-:location/create",
    name: "product-attributes-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "StorageLocation",
    },
    components: {
      content: lazyLoad("products/product-location-attribute"),
    },
  },
  {
    path: "/product-attribute-:location/review/:id",
    name: "product-attributes-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "StorageLocation",
    },
    components: {
      content: lazyLoad("products/product-location-attribute"),
    },
  },
  {
    path: "/product-attribute-:location/edit/:id",
    name: "product-attributes-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "StorageLocation",
    },
    components: {
      content: lazyLoad("products/product-location-attribute"),
    },
  },
  {
    path: "/location",
    name: "location-list",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "StorageLocation",
    },
    components: {
      content: lazyLoad("products/product-location"),
    },
  },
  {
    path: "/location/create",
    name: "location-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "StorageLocation",
    },
    components: {
      content: lazyLoad("products/product-location"),
    },
  },
  {
    path: "/location/review/:id",
    name: "location-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "StorageLocation",
    },
    components: {
      content: lazyLoad("products/product-location"),
    },
  },
  {
    path: "/location/edit/:id",
    name: "location-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "StorageLocation",
    },
    components: {
      content: lazyLoad("products/product-location"),
    },
  },
];
